<template>
    <div>
        <el-alert type="warning" :closable="false">说明：针对秀动各端，除下单模块之外（下单在演出上控制），是否出现三方验证码的控制开关</el-alert>
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
            size="medium"
            v-loading="dataLoading"
        >
            <el-card header="秀动APP乐迷版" class="MT20">
                <el-checkbox v-model="formData.appLogin" :true-label="1" :false-label="0">登录</el-checkbox>
                <el-checkbox v-model="formData.appPassword" :true-label="1" :false-label="0">修改密码</el-checkbox>
                <el-checkbox v-model="formData.appTelephone" :true-label="1" :false-label="0">修改绑定手机号</el-checkbox>
            </el-card>
			<el-card header="秀动APP专业版" class="MT20">
			    <el-checkbox v-model="formData.suduProLogin" :true-label="1" :false-label="0">登录</el-checkbox>
			</el-card>
            <el-card header="秀动Wap" class="MT20">
                <el-checkbox v-model="formData.wapLogin" :true-label="1" :false-label="0">登录</el-checkbox>
                <el-checkbox v-model="formData.wapLogout" :true-label="1" :false-label="0">账号注销</el-checkbox>
                <el-checkbox v-model="formData.wapRefund" :true-label="1" :false-label="0">退票</el-checkbox>
            </el-card>
            <el-card header="秀动经营平台" class="MT20">
                <el-checkbox v-model="formData.suduLogin" :true-label="1" :false-label="0">登录</el-checkbox>
                <el-checkbox v-model="formData.suduRegister" :true-label="1" :false-label="0">注册</el-checkbox>
                <el-checkbox v-model="formData.suduTelephone" :true-label="1" :false-label="0">修改负责人手机</el-checkbox>
                <el-checkbox v-model="formData.suduAccount" :true-label="1" :false-label="0">子账号管理</el-checkbox>
				<el-checkbox v-model="formData.suduResetPassword" :true-label="1" :false-label="0">重置密码</el-checkbox>
            </el-card>
            <el-card header="秀动管理后台" class="MT20">
                <el-checkbox v-model="formData.adminLogin" :true-label="1" :false-label="0">登录</el-checkbox>
            </el-card>
            <div class="MT20">
                <el-button type="primary" @click="submitForm()" :loading="btnLoading">保 存</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {
    data(){
        return{
            btnLoading:false,
            dataLoading:false,
            formData:{
                "adminLogin": 1,
                "appLogin": 1,
                "appPassword": 1,
                "appTelephone": 1,
                "suduAccount": 1,
                "suduLogin": 1,
                "suduRegister": 1,
                "suduTelephone": 1,
                "wapLogin": 1,
                "wapLogout": 1,
                "wapRefund": 1,
				"suduProLogin":1,
				"suduResetPassword":1
            },
            rules:{}
        }
    },
    created(){
        this.getDataDetails();
    },
    methods:{
        //获取详情
        getDataDetails(){
            this.dataLoading = true;
            this.$request({
                url: '/verificationSwitch/getInfo',
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.formData = {
                            ...this.formData,
                            ...result
                        }
                    } else {
                        this.$message.error(msg || "获取详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
         //表单提交
        submitForm(){
            this.$refs["formData"].validate( (valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/verificationSwitch/update',
                        data: {...this.formData},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$message.success("操作成功");
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.page-group-title{
    
}
</style>